import React from 'react';
import { EditOutlined } from '@ant-design/icons';
import PropTypes from 'prop-types';
import { Button, Flex } from 'atoms';

export default function EditModeBtn({ handleEdit, label, disabled }) {
	return (
		<Flex justifyContent="flex-end">
			<Button onClick={() => handleEdit()} type="button" disabled={disabled}>
				<EditOutlined /> {label || 'Edit'}
			</Button>
		</Flex>
	);
}

EditModeBtn.propTypes = {
	handleEdit: PropTypes.func,
	label: PropTypes.string,
	disabled: PropTypes.bool,
};

EditModeBtn.defaultProps = {
	disabled: false,
};
